/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EnableAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Confirmation from './Confirmation/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function EnableAction({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentAutomations/AutomationsList/EnableAutomationHub/Empty/EnableAction"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="EnableAction.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 justifyContent="flex-start"
 onChange={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Confirmation/Content'))}
 marginTop={dtSpaceM}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 text="Enable Automation Hub"
 weight="semibold"
 size="xmedium"
/>
</React.Fragment>
)}
</TysiaToggle>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Define your automations so they operate automatically in the background or manually by presenting the user options on what to do next."
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral500}
/>
<Confirmation
  viewPath={`${viewPath}/Confirmation`}
/>
</div>
{children}
</React.Fragment>)
}